import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { showSuccessSnackbar } from 'modules/snackbar';

import FilterCollection from 'components/organisms/FilterCollection';

import DisplayFilterWrap from './DisplayFilterWrap';

const DisplayFilter = (props) => {
  const {
    id,
    handleOnClickFilter,
    advrtsPrdtCode,
    displayFilterList,
    params,
    required = [],
    selectOnlyOne = false,
    useDisplayAll,
    onlyProducts = false,
    onlyTargeting = false,
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allProductCodeList = [], productCodeList = [] } = useSelector(
    ({ common }) => ({
      allProductCodeList: common.allProductCodeList,
      productCodeList: common.productCodeList,
    })
  );
  const [selectedPrdtCode, setSelectedPrdtCode] = useState(
    !!params.advrtsTpCode ? params.advrtsTpCode : '00'
  );

  const [selectedTpCodes, setSelectedTpCodes] = useState(
    !!params.advrtsPrdtCode ? params.advrtsPrdtCode : {}
  );
  const [filterList, setFilterList] = useState({
    allProductCode: productCodeList,
    productCode: productCodeList,
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // store에서 list 갱신되면 다시 담아내는 로직
    let newList = { ...filterList };
    if (newList.allProductCode !== allProductCodeList) {
      newList = { ...newList, allProductCode: allProductCodeList };
    }
    if (newList.productCode !== productCodeList) {
      newList = { ...newList, productCode: productCodeList };
    }
    setFilterList(newList);
    //eslint-disable-next-line
  }, [allProductCodeList, productCodeList]);

  useEffect(() => {
    handleSetValue();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleSetValue();
    // eslint-disable-next-line
  }, [params]);

  const handleSetValue = () => {
    if (typeof params.advrtsPrdtCode === 'undefined') {
      setSelectedPrdtCode('00');
    } else {
      setSelectedPrdtCode(params.advrtsPrdtCode);
    }

    if (typeof params.advrtsTpCode === 'undefined') {
      setSelectedTpCodes({});
    } else {
      let newAdvrtsTpCode = params.advrtsTpCode;
      let ObjTpCode = newAdvrtsTpCode.split(',');
      let result = {};
      for (let i = 0; ObjTpCode.length > i; i++) {
        const tempValue = ObjTpCode[i];
        result[tempValue] = 1;
      }
      setSelectedTpCodes(result);
    }
  };

  /**
   * 선택된 디스플레이 필터 리스트 반환
   * @param {array} tpCodeArray 선택한 tpCode 배열
   * @param {Map} allProductCodeList
   */
  const returnSelectedLabel = (codeList) => {
    let tpCodeArray = '';
    let resultStr = '';
    if (typeof params.advrtsTpCode !== 'undefined') {
      tpCodeArray = params.advrtsTpCode.split(',');

      const MAX = 1;
      const codeNameArray = [];

      for (let value of tpCodeArray) {
        if (codeList.get(value) !== undefined) {
          codeNameArray.push(codeList.get(value)['label']);
        }
      }
      if (codeNameArray.length <= MAX) {
        resultStr = codeNameArray.join(', ');
      } else {
        resultStr = i18next.t('외', {
          list: codeNameArray.slice(0, MAX).join(', '),
          count: codeNameArray.length - MAX,
        });
      }
    }
    return resultStr;
  };

  // 디스플레이 필터 상품을 선택했을 때 실행되는 함수
  const handleProductClick = (newPrdt) => {
    if (selectedPrdtCode !== newPrdt) {
      if (!!required) {
        if (required.includes('advrtsPrdtCode') && newPrdt === '00') {
          handleClickSnackbar({
            message: t('상품유형 선택은 필수입니다.'),
            option: { type: 'error' },
          });
        } else {
          setSelectedTpCodes({});
          if (newPrdt === '00') {
            let newParams = { ...params };
            delete newParams.advrtsTpCode;
            delete newParams.advrtsPrdtCode;
            handleOnClickFilter(newParams);
          }
          setSelectedPrdtCode(newPrdt);
        }
      } else {
        setSelectedTpCodes({});
        if (newPrdt === '00') {
          let newParams = { ...params };
          delete newParams.advrtsTpCode;
          delete newParams.advrtsPrdtCode;
          handleOnClickFilter(newParams);
        }
        setSelectedPrdtCode(newPrdt);
      }
    }
    if (selectOnlyOne) {
      // tp 값을 필수로 설정하고 prdt 를 선택했을 때
      handleClickSnackbar({
        message: t('타게팅 선택은 필수입니다.'),
        option: { type: 'info' },
      });
    }
  };

  const handleTpClick = (advrtsPrdtCode, advrtsTpCode, checked) => {
    let newTpCodes = { ...selectedTpCodes };

    if (selectedPrdtCode !== advrtsPrdtCode) {
      if (!(selectedPrdtCode === null && advrtsPrdtCode === null)) {
        newTpCodes = {};
      }
      if (advrtsPrdtCode === null) {
        // 타게팅별 필터링
        setSelectedPrdtCode(null);
      } else {
        // 상품별 필터링
        // 다른 상품 선택한 경우
        setSelectedPrdtCode(advrtsPrdtCode);
      }
    }

    if (advrtsTpCode === 'Y' || advrtsTpCode === 'N') {
      //타겟팅 리스트
      if (checked) {
        if (!!displayFilterList && advrtsPrdtCode === null) {
          for (let filterItem of Object.values(displayFilterList)) {
            for (let itemValue of Object.keys(filterItem)) {
              newTpCodes[itemValue] = 1;
            }
            break;
          }
        } else {
          for (let prdtItem of productCodeList.values()) {
            if (advrtsPrdtCode === null) {
              // 타겟팅별 전체선택
              for (let i = 0; i < prdtItem.item.length; i++) {
                newTpCodes[prdtItem.item[i].value] = 1;
              }
            } else if (prdtItem.value === advrtsPrdtCode) {
              // 상품별 전체선택

              if (!!displayFilterList) {
                newTpCodes = displayFilterList[advrtsPrdtCode];
              } else {
                for (let i = 0; i < prdtItem.item.length; i++) {
                  if (prdtItem.item[i].value === '00') continue;
                  newTpCodes[prdtItem.item[i].value] = 1;
                }
                break;
              }
            }
          }
        }
      } else {
        newTpCodes = {};
      }
    // 배열로 받으면, 해당 배열로만 선택되도록 (카트류, 본상품류 등 군집으로 선택되는 경우)
    } else if(Array.isArray(advrtsTpCode)) {
      newTpCodes = {};
      for (let filterItem of Object.values(advrtsTpCode)) {
          newTpCodes[filterItem] = 1;
      }
    } else {
      if (checked) {
        newTpCodes[advrtsTpCode] = 1;
      } else {
        delete newTpCodes[advrtsTpCode];
      }
    }
    if (!!required) {
      if (
        required.includes('advrtsTpCode') &&
        JSON.stringify(newTpCodes) === '{}'
      ) {
        // tp 값을 필수로 설정하고 아무것도 선택안했을때
        handleClickSnackbar({
          message: t('타게팅 선택은 필수입니다.'),
          option: { type: 'error' },
        });
      } else {
        setSelectedTpCodes(newTpCodes);
      }
    } else {
      setSelectedTpCodes(newTpCodes);
    }
  };

  // 디스플레이 선택 후 저장 버튼 눌렀을떄 실행되는 함수
  const handleSubmit = () => {
    let newParams = { ...params };
    const hasTpCode = JSON.stringify(selectedTpCodes) !== '{}';
    let tpCodes = Object.keys(selectedTpCodes).join(',');
    if (!!selectedPrdtCode && !hasTpCode) {
      // prdt만 선택했을떄
      newParams = { ...newParams, advrtsPrdtCode: selectedPrdtCode };
      delete newParams.advrtsTpCode;
    } else {
      // tp 값이 있을떄
      if (!!tpCodes) {
        newParams = {
          ...newParams,
          advrtsPrdtCode: selectedPrdtCode,
          advrtsTpCode: tpCodes,
        };
      } else {
        newParams = { ...newParams, advrtsPrdtCode: selectedPrdtCode };
      }
    }
    if (selectOnlyOne && !!newParams.advrtsTpCode) {
      if (newParams.advrtsTpCode.split(',').length > 1) {
        handleClickSnackbar({
          message: t('해당 페이지는 1개만 선택이 가능합니다.'),
          option: { type: 'error' },
        });
        return;
      }
    }

    // 값이 없는 상태에서는 newParams에서 삭제하는 로직
    if (!selectedPrdtCode) delete newParams['advrtsPrdtCode'];
    if (!tpCodes) delete newParams['advrtsTpCode'];

    if (!!required || !!selectOnlyOne) {
      // 필수 혹은 타게팅을 1개만 선택할때 접근하는 로직
      if (
        (selectOnlyOne || required.includes('advrtsTpCode')) &&
        !newParams['advrtsTpCode']
      ) {
        handleClickSnackbar({
          message: t('타게팅 선택은 필수입니다.'),
          option: { type: 'error' },
        });
      } else {
        handleOnClickFilter(newParams);
        setOpen(false);
      }
    } else {
      handleOnClickFilter(newParams);
      setOpen(false);
    }
  };

  let newLabel = () => {
    let result = '';
    if (!!advrtsPrdtCode) {
      result = productCodeList.get(advrtsPrdtCode).label;
    } else if (
      typeof params.advrtsTpCode === 'undefined' ||
      params.advrtsTpCode === '00'
    ) {
      result = t('광고 상품');
    } else {
      if (!!advrtsPrdtCode) {
        result = productCodeList.get(advrtsPrdtCode).label;
      } else {
        result = '';
      }
    }
    return result;
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      {filterList.allProductCode.size !== 0 && (
        <FilterCollection
          label={newLabel()}
          selectLabel={returnSelectedLabel(filterList.allProductCode)}
          filtered={
            typeof params.advrtsPrdtCode !== 'undefined' ||
            typeof params.advrtsTpCode !== 'undefined'
          }
          popoverHeight={720}
          open={open}
          openCallBack={(newValue, name) => {
            if (name === 'openFlag') setOpen(newValue);
          }}
        >
          <DisplayFilterWrap
            name={id}
            advrtsPrdtCode={selectedPrdtCode}
            advrtsTpCode={selectedTpCodes}
            displayFilterList={displayFilterList}
            params={params}
            useDisplayAll={useDisplayAll}
            onlyProducts={onlyProducts}
            onlyTargeting={onlyTargeting}
            handleProductClick={handleProductClick}
            handleSubmit={handleSubmit}
            handleTpClick={handleTpClick}
          />
        </FilterCollection>
      )}
    </>
  );
};

export default DisplayFilter;
